import angular from 'angular';
import uiRouter from 'angular-ui-router';
import sanitize from 'angular-sanitize';
import 'angular-local-storage';
import 'angular-animate';
import 'angular-aria';
import 'angular-material';
import 'angular-messages';
import { permission, uiPermission } from 'angular-permission';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import Drilldown from 'highcharts/modules/drilldown';
import 'highcharts-ng';
import mdTable from 'angular-material-data-table';
import 'ng-file-upload/dist/ng-file-upload';
import 'zd.ame-lightbox/dist/ame-lightbox';
import environment from 'environment';
import rootComponent from './root.component';
import common from './common/common.module';
import components from './components/components.module';
import themeConfig from './config/material-theme';
import httpConfig from './config/http';
import httpTransformConfig from './config/http-transform';
import permissionsConfig from './config/permissions/permissions.config';
// import highchartsTheme from './config/highcharts-theme';
import './root.scss';

Exporting(Highcharts);
Drilldown(Highcharts);
// Highcharts.theme = highchartsTheme;
// Highcharts.setOptions(highchartsTheme);
window.Highcharts = Highcharts; // necessary for https://github.com/highcharts/highcharts/issues/4994

export default angular
  .module('root', [
    uiRouter,
    sanitize,
    'LocalStorageModule',
    'ngMaterial',
    'highcharts-ng',
    'ngAnimate',
    'ngMessages',
    'ame.lightbox',
    'ngFileUpload',
    permission,
    uiPermission,
    mdTable,
    common,
    components
  ])
  .component('root', rootComponent)
  .config(themeConfig)
  .config(['$httpProvider', httpConfig])
  .config(['$httpProvider', httpTransformConfig])
  .config(($locationProvider) => {
    'ngInject';

    $locationProvider.html5Mode(true);
  })
  .config(($compileProvider) => {
    'ngInject';

    $compileProvider.debugInfoEnabled(environment.debugInfoEnabled);
    $compileProvider.preAssignBindingsEnabled(true);
  })
  .run(permissionsConfig)
  .run(($state, $transitions, LoadingService, ToastService) => {
    'ngInject';

    $transitions.onStart({}, (trans) => {
      LoadingService.start();
      trans.promise.finally(() => LoadingService.stop());
    });

    $state.defaultErrorHandler((error) => {
      // Ignore transition errors
      if (error && error.message && error.message === 'The transition has been superseded by a different transition') {
        return;
      }

      ToastService.showError(error);
    });
  })
  .name;



// WEBPACK FOOTER //
// ./root.module.js